import type { MascotPose } from "./Mascot";

export interface MascotZone {
  /** CSS selector to watch */
  selector: string;
  pose: MascotPose;
  /** rotating lines the buddy can say while this zone is on screen */
  lines: string[];
}

/**
 * Ordered by priority — the first matching zone that is on screen wins.
 * Works for both the ISP and MVNO pages.
 */
export const MASCOT_ZONES: MascotZone[] = [
  {
    selector: ".isp-page__simulator",
    pose: "point",
    lines: [
      "Escolhe o tema e brinca com as cores 🎨",
      "É esse app que vai pra loja, com a sua marca!",
      "Clica numa cor e vê a mágica acontecer ✨",
    ],
  },
  {
    selector: ".mvno-wiz",
    pose: "point",
    lines: [
      "Seis passos e o chip tá ativo 📱",
      "Testa a jornada de ativação, é rapidinho!",
      "eSIM na hora ou chip em casa — o cliente escolhe.",
    ],
  },
  {
    selector: ".isp-integrations",
    pose: "thumbs-up",
    lines: [
      "A gente conecta no sistema que você já usa 🔌",
      "SGP, IXC, HubSoft… tá tudo aqui.",
    ],
  },
  {
    selector: ".isp-plans",
    pose: "thumbs-up",
    lines: [
      "O plano Impulso é o queridinho 👀",
      "Sem fidelidade — você paga pelo tamanho da base.",
    ],
  },
  {
    selector: ".mvno-model",
    pose: "thumbs-up",
    lines: [
      "Você paga só pelo que ativa 💜",
      "Sem investir em infraestrutura pra virar operadora.",
    ],
  },
  {
    selector: ".site-footer",
    pose: "wave",
    lines: ["Curtiu? Bora conversar! 👋", "Qualquer dúvida, chama a gente."],
  },
  {
    selector: ".mvno-hero, .isp-hero",
    pose: "wave",
    lines: [
      "Oi! Sou o mascote da Provenduz 👋",
      "Dá uma rolada, te mostro tudo.",
    ],
  },
];

export const GENERIC_LINES = [
  "Precisa de ajuda? É só clicar 😄",
  "Tô por aqui se precisar!",
  "Bora deixar o app com a sua cara?",
];
